import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MagnifyingGlass } from '@phosphor-icons/react';

export const NotFoundPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.default,
        px: 3,
        textAlign: 'center'
      }}
    >
      {/* 404 Icon */}
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          backgroundColor: theme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.05)' 
            : 'rgba(0, 0, 0, 0.04)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3
        }}
      >
        <MagnifyingGlass 
          size={24} 
          weight="regular"
          color={theme.palette.text.secondary}
          style={{ opacity: 0.5 }}
        />
      </Box>

      {/* 404 Text */}
      <Typography
        sx={{
          fontSize: '72px',
          fontWeight: 700,
          color: theme.palette.text.primary,
          lineHeight: 1,
          mb: 1,
          opacity: 0.1
        }}
      >
        404
      </Typography>

      {/* Message */}
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 600,
          color: theme.palette.text.primary,
          mb: 1
        }}
      >
        Page not found
      </Typography>

      <Typography
        sx={{
          fontSize: '14px',
          color: theme.palette.text.secondary,
          mb: 4,
          maxWidth: 400
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </Typography>

      {/* Action */}
      <Button
        variant="contained"
        startIcon={<ArrowLeft size={18} />}
        onClick={() => navigate(-1)}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: '8px',
          px: 3,
          backgroundColor: theme.palette.mode === 'dark' ? '#3b82f6' : '#1A1A1A',
          color: 'white',
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? '#2563eb' : '#000'
          }
        }}
      >
        Go Back
      </Button>
    </Box>
  );
};

export default NotFoundPage;

